import { useQuery } from "@tanstack/react-query"
import { zendeskTicketAuditsQuery } from "../lib/zendeskTicketAuditsQuery"

export function useZendeskTicketAuditsQuery(...args: Parameters<typeof zendeskTicketAuditsQuery>) {
  return useQuery(zendeskTicketAuditsQuery(...args))
}
